import * as Types from '../../types';

import { gql } from '@apollo/client';
import { EntityRiskIndicatorFragmentDoc } from '../../components/RiskIndicator/RiskIndicator.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEntitiesQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  sort?: Types.InputMaybe<Types.SortInput>;
  filters?: Types.InputMaybe<Array<Types.FilterInput> | Types.FilterInput>;
}>;

export type GetEntitiesQuery = {
  __typename?: 'Query';
  entities: {
    __typename?: 'EntityConnection';
    totalCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
    edges: Array<{
      __typename?: 'EntityEdge';
      cursor: string;
      node: {
        __typename?: 'Entity';
        id: any;
        name: string;
        location?: string | null;
        risks: {
          __typename?: 'EntityRiskConnection';
          totalCount: number;
          pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            hasPreviousPage: boolean;
            startCursor?: string | null;
            endCursor?: string | null;
          };
          edges: Array<{
            __typename?: 'EntityRiskEdge';
            node: {
              __typename?: 'EntityRisk';
              id: any;
              riskType: string;
              severity: string;
              description?: string | null;
            };
          }>;
        };
        addresses: { __typename?: 'AddressConnection'; totalCount: number };
      };
    }>;
  };
};

export const GetEntitiesDocument = gql`
  query GetEntities(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $sort: SortInput
    $filters: [FilterInput!]
  ) {
    entities(
      after: $after
      before: $before
      first: $first
      last: $last
      sort: $sort
      filters: $filters
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          id
          name
          location
          risks {
            ...EntityRiskIndicator
          }
          addresses {
            totalCount
          }
        }
      }
    }
  }
  ${EntityRiskIndicatorFragmentDoc}
`;

/**
 * __useGetEntitiesQuery__
 *
 * To run a query within a React component, call `useGetEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntitiesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetEntitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEntitiesQuery,
    GetEntitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEntitiesQuery, GetEntitiesQueryVariables>(
    GetEntitiesDocument,
    options,
  );
}
export function useGetEntitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEntitiesQuery,
    GetEntitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEntitiesQuery, GetEntitiesQueryVariables>(
    GetEntitiesDocument,
    options,
  );
}
export function useGetEntitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEntitiesQuery,
        GetEntitiesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEntitiesQuery, GetEntitiesQueryVariables>(
    GetEntitiesDocument,
    options,
  );
}
export type GetEntitiesQueryHookResult = ReturnType<typeof useGetEntitiesQuery>;
export type GetEntitiesLazyQueryHookResult = ReturnType<
  typeof useGetEntitiesLazyQuery
>;
export type GetEntitiesSuspenseQueryHookResult = ReturnType<
  typeof useGetEntitiesSuspenseQuery
>;
export type GetEntitiesQueryResult = Apollo.QueryResult<
  GetEntitiesQuery,
  GetEntitiesQueryVariables
>;
